var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"mx-24"}),_c('div',{staticClass:"box",style:({
      'background-color': _vm.color,
    }),on:{"click":_vm.HshColorPicker}})])
}
var staticRenderFns = []

export { render, staticRenderFns }